import React, { useRef } from 'react';
import { ScreenConfig } from 'new/routes/RouterManager';
import { FlowRunsHeaderMemo } from './components/FlowRunsHeader/FlowRunsHeader';
import { FlowRunsTable } from './components/FlowRunsTable/FlowRunsTable';
import { useFlowRunsTable } from './hooks/useFlowRuns';
import { generateColumnsForFlowRunsTable } from 'new/components/monitor/Runs/components/FlowRunsTable/generateColumnsForFlowRunsTable';
import { useTriageLauncher } from 'new/components/monitor/TriageChat/TriageChatProvider';
import { buildTriageContextFromRow } from 'new/components/monitor/TriageChat/triageContext';

function FlowRunsScreen() {
  const parentScrollRef = useRef<HTMLDivElement>(null);
  const [{ loading, data, error, meta, lastUpdated }, { refresh }] = useFlowRunsTable();

  // Conversational triage is launched through the app-level provider (single
  // modal, deep-link handling, flag gating all live there).
  const triage = useTriageLauncher();

  return (
    <div ref={parentScrollRef} aria-label="run-screen-container">
      <FlowRunsHeaderMemo
        meta={meta}
        isLoading={loading}
        onRefresh={refresh}
        lastUpdated={lastUpdated}
      />

      <FlowRunsTable
        data={data}
        error={error}
        loading={loading}
        parentScrollRef={parentScrollRef}
        generateColumns={generateColumnsForFlowRunsTable}
        triageChatEnabled={triage.enabled}
        onOpenTriage={(row) => triage.open(buildTriageContextFromRow(row), 'flow_run_row')}
      />
    </div>
  );
}

FlowRunsScreen.screenConfig = {
  path: '/monitor/runs',
  domain: 'monitor',
  header: {
    title: 'Runs',
    slugTitle: 'Runs',
  },
  screenName: 'FlowRuns',
} as ScreenConfig<{}>;

export { FlowRunsScreen };
